import { action } from 'typesafe-actions';
import { DocumentType } from './types';

interface Document {
  company: any;
  pageNm?: string;
  newPage: any;
  rowsPerPage: any;
}

export const documentRequest = ({
  company,
  pageNm,
  newPage,
  rowsPerPage,
}: Document) =>
  action(DocumentType.DOCUMENT_RESQUEST, {
    company,
    pageNm,
    newPage,
    rowsPerPage,
  });

export const documentSuccess = (data: any) =>
  action(DocumentType.DOCUMENT_SUCCESS, { data });

export const documentFailure = () => action(DocumentType.DOCUMENT_FAILURE, {});

export const getDocumentRequest = (company: any, id: any) =>
  action(DocumentType.GET_DOCUMENT_RESQUEST, {
    company,
    id,
  });

export const getDocumentSuccess = (data: any) =>
  action(DocumentType.GET_DOCUMENT_SUCCESS, { data });

export const getDocumentFailure = () =>
  action(DocumentType.GET_DOCUMENT_FAILURE, {});

interface PostDocument {
  page_id?: number;
  page_type_fl: any;
  status_fl: any;
  country_company_id: any;
  user_executor: string;
  page_nm: string;
  page_content_ds: any;
}
export const postDocumentRequest = (document: PostDocument) =>
  action(DocumentType.POST_DOCUMENT_RESQUEST, {
    document,
  });

export const postDocumentSuccess = () =>
  action(DocumentType.POST_DOCUMENT_SUCCESS, {});

export const postDocumentFailure = () =>
  action(DocumentType.POST_DOCUMENT_FAILURE, {});

export const areasRequest = (company: any) =>
  action(DocumentType.AREA_RESQUEST, {
    company,
  });

export const areasSuccess = (data: any) =>
  action(DocumentType.AREA_SUCCESS, { data });

export const areasFailure = () => action(DocumentType.AREA_FAILURE, {});

export const tratamentoAtividadesRequest = (newPage: any, rowsPerPage: any) =>
  action(DocumentType.MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST, {
    newPage,
    rowsPerPage,
  });

export const tratamentoAtividadesSuccess = (data: any) =>
  action(DocumentType.MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS, { data });

export const tratamentoAtividadesFailure = () =>
  action(DocumentType.MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE, {});

interface AtividadesTitulares {
  data_holder_cat_id: number;
  data_operation_id: number;
  status_fl: string;
  country_company_id: number;
}
interface PostTratamentoAtividades {
  data_operation_id: number;
  data_treat_operation_nm: string;
  area_ds: any;
  consent_type_fl: string;
  status_fl: string;
  country_company_id: number;
  responsable_nm: any;
  responsable_contact_ds: any;
  atividade_titular: AtividadesTitulares[];
}

export const updateTratamentoAtividadesRequest = (row: any) =>
  action(DocumentType.UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST, {
    row,
  });

export const updateTratamentoAtividadesSuccess = () =>
  action(DocumentType.UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS, {});

export const updateTratamentoAtividadesFailure = () =>
  action(DocumentType.UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE, {});

export const postTratamentoAtividadesRequest = (row: any) =>
  action(DocumentType.POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST, {
    row,
  });

export const postTratamentoAtividadesSuccess = () =>
  action(DocumentType.POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS, {});

export const postTratamentoAtividadesFailure = () =>
  action(DocumentType.POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE, {});

export const deleteTratamentoAtividadesRequest = (row: any) =>
  action(DocumentType.DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST, {
    row,
  });

export const deleteTratamentoAtividadesSuccess = () =>
  action(DocumentType.DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS, {});

export const deleteTratamentoAtividadesFailure = () =>
  action(DocumentType.DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE, {});

export const changeInsert = (make: string) =>
  action(DocumentType.CHANGE_INSERT, { make });

export const resetPage = (make: number) =>
  action(DocumentType.RESET_PAGE, { make });

export const cleanModal = () => action(DocumentType.CLEAN_MODAL, {});
